import { getWindow } from '@databases/connect';

import { useUserLocale } from '@canvas/canvas-state';

import { getBrowserDefaultLocale } from '../constants';

export const useLocale = () => {
  const window = typeof globalThis.window !== 'undefined' ? getWindow() : undefined;
  const localeOverride = window
    ? new URLSearchParams(window.location.search).get('databases-locale-override')
    : null;
  const DEFAULT_LOCALE = getBrowserDefaultLocale();

  // For translation test sites
  let translationContextLocale = DEFAULT_LOCALE;

  try {
    translationContextLocale = window
      ? window.parent?.__SSR_LOCALE__ ??
        window.parent?.__INITIAL_STATE__?.i18n?.locale ??
        DEFAULT_LOCALE
      : DEFAULT_LOCALE;

    if (translationContextLocale.includes('_')) {
      // locale from session data takes the form of en_US instead of en-US
      translationContextLocale = translationContextLocale.replace('_', '-');
    }
    // eslint-disable-next-line canvas/no-swallow-errors-in-catch
  } catch (error) {
    // Fails when cross-origin. Allowing it to fail silently because we will use locale from identity
  }

  const userLocale = useUserLocale();

  if (localeOverride) {
    return localeOverride;
  }

  if (translationContextLocale === 'en-ZZ') {
    return translationContextLocale;
  }

  return userLocale;
};
